export default class AccountsV2Setup {

  constructor() {}

  render() {

    // Poll for setup status
    let setupStatusPoll = () => {
      let accountUrl = $('body').attr('data-account-url');
      let params = {}
      params['skip_setup'] = $('.progress-bar').data('skip-setup');
      let url = '/' + accountUrl + '/v2_setup.js';

      // Execute ajax request
      $.ajax({
        type: "GET",
        dataType: "script",
        timeout: 2000,
        url: url + '?' + $.param(params),
        complete() {
          setTimeout(function() { setupStatusPoll() }, 2000);
        }
      });

    };

    // Poll server for status of account setup
    setupStatusPoll();

  }

}